import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal, Button, Form } from 'react-bootstrap';
import CloseIcon from '../../layouts/SVG/CloseIcon';
import CustomAlert from '../../components/CustomAlert';
import { uploadFile } from '../../helpers/apiHandler';
import { FileUploader } from 'react-drag-drop-files';
import UploadIconSVG from '../../layouts/SVG/UploadIconSVG';
import ClosableChip from '../ClosableChip';

const GlobalRatesUploadModel = ({ show, onClose, getGlobalRatesData }) => {
  const { access_token } = useSelector((state) => state.auth.user);
  const [file, setFile] = useState();
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const handleFileAttach = (files) => {
    setFile(files);
  };

  const handleFileClear = () => {
    setFile();
  };

  const handleFileUpload = () => {
    if (!file) {
      setAlertState({
        message: 'No file selected. Please choose a file to upload.',
        show: true,
        variant: 'danger',
      });
      return;
    }

    uploadFile('/admin/global-rates-upload', file, access_token.token, (res) => {
      if (res.success) {
        setAlertState({
          message: 'Uploaded global rates file successfully',
          show: true,
          variant: 'success',
        });
        getGlobalRatesData();
        setFile(null);
        onClose();
      } else {
        setAlertState({
          message: 'Failed to upload globla rates file',
          show: true,
          variant: 'danger',
        });
      }
    });
  };

  return (
    <>
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <Modal show={show} onHide={onClose} centered>
        <Modal.Body>
          <CloseIcon handleModalClose={onClose} />
          <Modal.Title as="h4" style={{ margin: '8px 0 16px' }}>
            Upload Global Rates
          </Modal.Title>
          <Form.Group
            style={{
              background: '#ebfaff',
              border: '2px dashed #0ba9e0',
              borderRadius: '16px',
              boxShadow: '0 2.75px 9px 0 #00000030, 0 .25px 3px 0 #0000000a',
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              padding: '16px',
              textAlign: 'center',
            }}
          >
            <FileUploader
              name="file"
              label="Upload File"
              types={['CSV', 'XLS', 'XLSX']}
              handleChange={handleFileAttach}
            >
              <div className="file-uploader">
                <div className="file-uploader-title">
                  Drag & Drop files here or <span className="browse-link">Browse files</span>
                </div>
                {!file ? (
                  <UploadIconSVG fill="#0BA9E0" />
                ) : (
                  <div className="file-loaded-message">
                    <ClosableChip text={file.name} onClick={handleFileClear} />
                  </div>
                )}
                <div className="file-upload-accept">Supported format: CSV, XLS and XLSX</div>
              </div>
            </FileUploader>
          </Form.Group>
          <div className="d-flex justify-content-right" style={{ marginTop: 24, gap: 16 }}>
            <Button variant="primary" onClick={handleFileUpload} style={{ minWidth: 160 }}>
              Update
            </Button>
            <Button variant="ghost" onClick={onClose} style={{ minWidth: 160 }}>
              Cancel
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GlobalRatesUploadModel;
